module.exports = __webpack_public_path__ + "static/ba138f18-4c91-4201-b277-5d68931d6f9a-2beb8f0909a47e19332300577004f6b5.jpeg";